import Http from '../../../shared/http'
import toastr from 'toastr'

import {
  SET_REMINDERS,
  SET_LOADING,
  SET_DESTROYING,
  GO_TO_ERROR,
  REMINDER_CREATED,
  REMINDER_UPDATED,
  REMINDER_DELETED
} from '../actions'

export const createReminder = async (state, values, dispatch) => {
  const { remindersPath } = state
  const message = 'Something went wrong while trying to create the reminder'

  try {
    const response = await postReminder(remindersPath, values)

    if (!response.ok) dispatch({ type: GO_TO_ERROR, payload: { message } }) // delegate request errors to connection error handler

    const { reminders } = await response.json()

    toastr.success('Reminder created successfully.')

    dispatch({ type: REMINDER_CREATED, payload: { reminders } })
  } catch (error) {
    dispatch({ type: GO_TO_ERROR, payload: { message } })
  }
}

export const updateWealthManagerReminder = async (state, values, dispatch) => {
  const { remindersPath, reminder } = state
  const message = 'Something went wrong while trying to update the reminder'

  try {
    const response = await updateReminder(remindersPath, values, reminder.id)
    if (!response.ok) dispatch({ type: GO_TO_ERROR, payload: { message } }) // delegate request errors to connection error handler

    const { reminders } = await response.json()

    toastr.success('Reminder updated successfully.')

    dispatch({ type: REMINDER_UPDATED, payload: { reminders } })
  } catch (error) {
    dispatch({ type: GO_TO_ERROR, payload: { message } })
  }
}

export const getWealthManagerReminders = (state, dispatch) => {
  (async () => {
    dispatch({ type: SET_LOADING, payload: { isLoading: true } })

    const { remindersPath } = state
    const message = 'Something went wrong while trying to fetch your reminders'

    try {
      const response = await getReminders(remindersPath)
      if (!response.ok) dispatch({ type: GO_TO_ERROR, payload: { message } }) // delegate request errors to connection error handler

      const { reminders } = await response.json()

      dispatch({ type: SET_REMINDERS, payload: { reminders } })
    } catch (error) {
      dispatch({ type: GO_TO_ERROR, payload: { message } })
    }
    dispatch({ type: SET_LOADING, payload: { isLoading: false } })
  })()
}

export const deleteWealthManagerReminder = async (state, dispatch) => {
  dispatch({ type: SET_DESTROYING, payload: { isDestroying: true } })

  const { remindersPath, reminder } = state
  const message = 'Something went wrong while trying to delete the reminder'

  try {
    const response = await deleteReminder(remindersPath, reminder.id)
    if (!response.ok) dispatch({ type: GO_TO_ERROR, payload: { message } }) // delegate request errors to connection error handler

    const { reminders } = await response.json()

    toastr.success('Reminder deleted successfully.')

    dispatch({ type: REMINDER_DELETED, payload: { reminders } })
  } catch (error) {
    dispatch({ type: GO_TO_ERROR, payload: { message } })
  }
  dispatch({ type: SET_DESTROYING, payload: { isDestroying: true } })
}

const postReminder = async (remindersPath, formData) => {
  return Http.request(remindersPath, 'POST', JSON.stringify(formData))
}

const updateReminder = async (remindersPath, formData, reminderId) => {
  return Http.request(`${remindersPath}/${reminderId}`, 'PUT', JSON.stringify(formData))
}

const getReminders = async (remindersPath) => {
  return Http.request(remindersPath, 'GET')
}

const deleteReminder = async (remindersPath, reminderId) => {
  return Http.request(`${remindersPath}/${reminderId}`, 'DELETE')
}
